import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IPeerMonitor } from '../../../common/monitor';

@Component({
    selector: 'extension',
    template: require('./extension.component.html')
})
export class ExtensionComponent implements OnInit {
    zeroDate: number;
    @Input() mod: boolean;
    @Input() exten: IPeerMonitor;
    @Output() editar = new EventEmitter <IPeerMonitor>();
    
    constructor() { 
        let _date = new Date(0);
        _date.setHours(0);
        this.zeroDate = _date.getTime();
    }
    
    editarExt(peer: IPeerMonitor) {
        if (this.mod)
            this.editar.emit(peer);
    }

    ngOnInit() { }
} 


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/admin/consola_ext/extension.component.ts